import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UmbracoLink } from '@models/umbraco.model';
import { LinkComponent } from '@shared/routing/link/link.component';
import { NgClass, NgFor, NgTemplateOutlet } from '@angular/common';
import { AccordionComponent } from '@shared/accordion/accordion.component';

@Component({
    selector: 'app-footer-group',
    templateUrl: './footer-group.component.html',
    styleUrls: ['./footer-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccordionComponent, NgFor, LinkComponent, NgClass, NgTemplateOutlet]
})
export class FooterGroupComponent {
    @Input()
    public readonly headline?: string;

    @Input()
    public readonly firstLinkBold?: boolean = false;

    @Input()
    public readonly links?: UmbracoLink[];
}
